import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {AlertService, ConstantService, UserService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { EmployeeProfile } from "../employee-profile";
import { EmployeeProfileService } from "../employee-profile.service";
import {first} from 'rxjs/operators';

@Component({
    selector: "app-employee-profile",
    templateUrl: "./employee-profile.component.html",
    styleUrls: ["./employee-profile.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class EmployeeProfileComponent implements OnInit {
  genders: any;
  titles: { name: string; value: string; }[];
  locations: any[];
  jobLevels: any;
  jobCategories: any;
  listingStatuses: any;
  countries: any;
  states: any;
  statuses: any;
  constructor(
    private primengConfig: PrimeNGConfig,
    private employeeProfileService: EmployeeProfileService,
    private alertService: AlertService,
    private messageService: MessageService,
    private userService: UserService,
    private constantService: ConstantService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title;
		this.employeeProfile = data.employeeProfile;
		this.taxStatuses = employeeProfileService.taxStatuses;
		this.taxExemptElects = employeeProfileService.taxExemptElects;
		this.termReasons = employeeProfileService.termReasons;
		this.payRateFreqs = employeeProfileService.payRateFreqs;
		this.contractOrPerms = employeeProfileService.contractOrPerms;
		this.salaryOrHourlys = employeeProfileService.salaryOrHourlys;
    this.genders = employeeProfileService.genders;    
    this.titles = employeeProfileService.titles;
    this.jobLevels = employeeProfileService.jobLevels;
    this.jobCategories = employeeProfileService.jobCategories;
    this.locations = this.constantService.locations;
    this.listingStatuses = employeeProfileService.listingStatuses;
    this.countries = this.constantService.countries; 
			this.states = this.constantService.states;
      this.statuses = employeeProfileService.statuses;
  }

  @Input() employeeProfile: EmployeeProfile;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  employeeProfileId: number;
  userId: any;
  users: any[];


  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

	taxStatuses: any;
	taxExemptElects: any;
	termReasons: any;
	payRateFreqs: any;
	contractOrPerms: any;
	salaryOrHourlys: any;

  validationMessages = {
    employeeProfileId: [],
    firstName: [{ type: 'required', message: 'Required' }],
    lastName: [{ type: 'required', message: 'Required' }],
    suffix: [],
    title: [],
    emailAddress: [
      { type: 'required', message: 'Eamil address is required' },
      { type: 'email', message: 'Enter a valid email address' }
    ],
    perEmailAddress: [],
    mobilePhone: [],
    perMobilePhone: [],
    taxStatus: [],
    taxExemptElect: [],
    hireDate: [],
    startDate: [],
    termDate: [],
    termReason: [],
    eligForRehire: [],
    positionName: [],
    payRate: [],
    payRateFreq: [],
    contractOrPerm: [],
    salaryOrHourly: [],
    adrType: [],
    adrStreet: [],
    adrStreet2: [],
    adrCity: [],
    adrState: [],
    adrPostalCode: [],
    adrCountry: [],
    adrPhone: [],
    adrFax: [],
    familyDesc: [],
    favSportsDesc: [],
    educationDesc: [],
    politicsDesc: [],
    opsNotes: [],
    anniversary: [],
    birthday: [],
    gender: [],
    socSecNum: [],
    emergencyContact: [],
    userId: [],
    listingStatus: [],
    jobCategory: [],
    jobLevel: [],
    locationId: [],
  };


  ngOnInit() {
    this.primengConfig.ripple = true;
    this.fetchUsers();
    this.formBuild();
    // if we were passed the whole employeeProfile object
    if (this.employeeProfile) {
      this.employeeProfileId = this.employeeProfile.employeeProfileId;
      if(this.employeeProfile.hireDate != undefined && this.employeeProfile.hireDate != null){
				this.employeeProfile.hireDate = moment.utc(this.employeeProfile.hireDate).toDate();
			}
      if(this.employeeProfile.startDate != undefined && this.employeeProfile.startDate != null){
				this.employeeProfile.startDate = moment.utc(this.employeeProfile.startDate).toDate();
			}
      if(this.employeeProfile.termDate != undefined && this.employeeProfile.termDate != null){
				this.employeeProfile.termDate = moment.utc(this.employeeProfile.termDate).toDate();
			}
      if(this.employeeProfile.anniversary != undefined && this.employeeProfile.anniversary != null){
				this.employeeProfile.anniversary = moment.utc(this.employeeProfile.anniversary).toDate();
			}
      if(this.employeeProfile.birthday != undefined && this.employeeProfile.birthday != null){
				this.employeeProfile.birthday = moment.utc(this.employeeProfile.birthday).toDate();
			}
      this.fixDates();
      this.form1.patchValue(this.employeeProfile);
    }
  }

  onFormDelete() {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message:
        "Are you sure you want to delete Id# " + this.employeeProfileId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete();
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      if ( this.form1.value.userId){
        this.form1.value.userId = this.form1.value.userId.userId;
      }
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.employeeProfileService.add(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.employeeProfile = res.data.employeeProfile;
          this.doAdd.emit(this.employeeProfile);
        },
        (err: any) => {
          console.log("employeeProfile-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log("employeeProfile: " + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.employeeProfileService.update(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-update SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.employeeProfile = res.data.employeeProfile;
          this.doUpdate.emit(this.employeeProfile);
        },
        (err: any) => {
          console.log("property-update FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.employeeProfileService
        .delete(this.employeeProfile.employeeProfileId)
        .subscribe(
          (res: any) => {
            console.log(
              "employeeProfile-delete SUCCESS: " + JSON.stringify(res)
            );
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: res.message,
            });
            this.doDelete.emit(this.employeeProfile);
          },
          (err: any) => {
            console.log("employeeProfile-add FAIL: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.formLoading = false;
          }
        );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      employeeProfileId: [this.employeeProfileId],
      firstName: ['',Validators.required],
      lastName: ['',Validators.required],
      suffix: [],
      title: [],
      emailAddress: ['', Validators.compose([
				Validators.required,
				Validators.email
			])],
      perEmailAddress: [],
      mobilePhone: [],
      perMobilePhone: [],
      taxStatus: [],
      taxExemptElect: [],
      hireDate: [],
      startDate: [],
      termDate: [],
      termReason: [],
      eligForRehire: [],
      positionName: [],
      payRate: [],
      payRateFreq: [],
      contractOrPerm: [],
      salaryOrHourly: [],
      adrType: [],
      adrStreet: [],
      adrStreet2: [],
      adrCity: [],
      adrState: [],
      adrPostalCode: [],
      adrCountry: [],
      adrPhone: [],
      adrFax: [],
      familyDesc: [],
      favSportsDesc: [],
      educationDesc: [],
      politicsDesc: [],
      opsNotes: [],
      anniversary: [],
      birthday: [],
      gender: [],
      socSecNum: [],
      emergencyContact: [],
      userId: [],
      listingStatus: [],
      jobCategory: [],
      jobLevel: [],
      locationId: [],
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?

  }

  fetchUsers() {
    if (!this.users || this.users === undefined || this.users.length < 1) {
      try {
        this.userService.findAll()
          .subscribe(
            res => {
              console.log('findAll Users: ' + JSON.stringify(res));
              this.users = res.data.users;
              return this.users;
            },
            err => {
              console.log('Feature-Update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      // console.log('properties are ' + this.properties);
      return (this.users);
    }
  }

  /* Search for user */
  findUsersWith(queryString: string)
  {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.users = [];
        this.users = data.data.userSummaryList;
        this.users.forEach(user => {
          user.fullName = user.lastName + ' ' + user.firstName + ' ' + user.emailAddress + ' ' + user.userId;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }

  /* Search for user */
  findUserById(userId: any)
  {
    this.userService.findById(userId).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.form1.patchValue({
          userId: data.data.user
        });
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }

  /* On each keystroke search for the user */
  onKeyInput(event)
  {
    let query = event.query;
    this.findUsersWith(query);
    return this.users;
  }

  onUserSeleted(user: any) {
    this.form1.patchValue({
      emailAddress: user.emailAddress,
      firstName: user.firstName,
      lastName: user.lastName,
      title: user.title,
      mobilePhone: user.mobilePhone,
      homeCity: user.adrCity,
      socSecNum: user.sSN,
      adrState: user.homeState,
      adrCity: user.homeCity,
    });
  }

  userInfo(event: any){
    console.log("userInfo: " + JSON.stringify(event));
    event.fullName = event.firstName +" "+event.lastName;
    this.form1.patchValue({
      userId: event,
      firstName: event.firstName,
      lastName: event.lastName,
      emailAddress: event.email,
      mobilePhone: event.phone
    });
  }
}
